// Display labels only; preserve shared round IDs and stored workflow definitions.
export function recruitmentRoundLabel(name: string): string {
  const key = name.toLowerCase().replace(/[^a-z0-9]/g, '')
  return ({ gdround: 'Group Discussion', piround1: 'Personal Interview 1', piround2: 'Personal Interview 2' } as Record<string, string>)[key] || name
}
